export const LINK_PREVIEW_URLS = {
  get_preview_data: "https://jsonlink.io/api/extract",
};
